import type { ICheckoutContext } from '@/types/context';
import { createContext } from 'react';

export const CheckoutContext = createContext<ICheckoutContext>({} as ICheckoutContext);
